import React from 'react'
import "./about.css" 

function About() {
  return (
    <div>
      <div className="container">
        <h1>About me</h1>
        <div className="about-container">
          <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
 
Sapiente delectus,Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
 Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
          </p>
        </div>
        </div>
    </div>
  )
}

export default About